export default __webpack_public_path__ + "static/media/04.eec13708.jpg";